export const DESTINY_CONTAINER_TYPE = {
  OPENED: 1,
  CLOSED: 2,
  PAUSED: 3,
  AVAILABLE: 4,
};

export const ORIGIN_CONTAINER_TYPE = {
  UNPROCESSED: 1,
  PROCESSING: 2,
  PAUSED: 3,
  EMPTIED: 4,
};

export const DESTINY_CONTAINER_TYPE_LABEL: Record<number, string> = {
  [DESTINY_CONTAINER_TYPE.OPENED]: 'Abierto',
  [DESTINY_CONTAINER_TYPE.CLOSED]: 'Cerrado',
  [DESTINY_CONTAINER_TYPE.PAUSED]: 'Pausado',
  [DESTINY_CONTAINER_TYPE.AVAILABLE]: 'Disponible',
}

export const ORIGIN_CONTAINER_TYPE_LABEL: Record<number, string> = {
  [ORIGIN_CONTAINER_TYPE.UNPROCESSED]: 'Sin Procesar',
  [ORIGIN_CONTAINER_TYPE.PROCESSING]: 'En Proceso',
  [ORIGIN_CONTAINER_TYPE.PAUSED]: 'Pausado',
  [ORIGIN_CONTAINER_TYPE.EMPTIED]: 'Vaciado',
}

export const DESTINY_CONTAINER_TYPE_COLOR: Record<number, 'secondary' | 'warning' | 'info' | 'success'> = {
  [DESTINY_CONTAINER_TYPE.OPENED]: 'info',
  [DESTINY_CONTAINER_TYPE.CLOSED]: 'success',
  [DESTINY_CONTAINER_TYPE.PAUSED]: 'warning',
  [DESTINY_CONTAINER_TYPE.AVAILABLE]: 'secondary',
}

export const ORIGIN_CONTAINER_TYPE_COLOR: Record<number, 'secondary' | 'warning' | 'info' | 'success'> = {
  [ORIGIN_CONTAINER_TYPE.UNPROCESSED]: 'info',
  [ORIGIN_CONTAINER_TYPE.PROCESSING]: 'success',
  [ORIGIN_CONTAINER_TYPE.PAUSED]: 'warning',
  [ORIGIN_CONTAINER_TYPE.EMPTIED]: 'secondary',
}

export const DESTINY_CONTAINER_TYPES = [
  { name: DESTINY_CONTAINER_TYPE_LABEL[DESTINY_CONTAINER_TYPE.OPENED], value: DESTINY_CONTAINER_TYPE.OPENED },
  { name: DESTINY_CONTAINER_TYPE_LABEL[DESTINY_CONTAINER_TYPE.CLOSED], value: DESTINY_CONTAINER_TYPE.CLOSED },
  { name: DESTINY_CONTAINER_TYPE_LABEL[DESTINY_CONTAINER_TYPE.PAUSED], value: DESTINY_CONTAINER_TYPE.PAUSED },
  { name: DESTINY_CONTAINER_TYPE_LABEL[DESTINY_CONTAINER_TYPE.AVAILABLE], value: DESTINY_CONTAINER_TYPE.AVAILABLE },
]

export const ORIGIN_CONTAINER_TYPES = [
  { name: ORIGIN_CONTAINER_TYPE_LABEL[ORIGIN_CONTAINER_TYPE.UNPROCESSED], value: ORIGIN_CONTAINER_TYPE.UNPROCESSED },
  { name: ORIGIN_CONTAINER_TYPE_LABEL[ORIGIN_CONTAINER_TYPE.PROCESSING], value: ORIGIN_CONTAINER_TYPE.PROCESSING },
  { name: ORIGIN_CONTAINER_TYPE_LABEL[ORIGIN_CONTAINER_TYPE.PAUSED], value: ORIGIN_CONTAINER_TYPE.PAUSED },
  { name: ORIGIN_CONTAINER_TYPE_LABEL[ORIGIN_CONTAINER_TYPE.EMPTIED], value: ORIGIN_CONTAINER_TYPE.EMPTIED },
]